import common from './common';
import header from './header';
import footer from './footer';
import cookieBanner from './cookieBanner';
import accountNav from './accountNav';
import home from './home';
import catalog from './catalog';
import product from './product';
import cart from './cart';
import checkout from './checkout';
import auth from './auth';
import account from './account';
import settings from './settings';
import billing from './billing';
import orders from './orders';
import favorites from './favorites';
import help from './help';
import legal from './legal';
import errors from './errors';

export default {
  common,
  header,
  footer,
  cookieBanner,
  accountNav,
  home,
  catalog,
  product,
  cart,
  checkout,
  auth,
  account,
  settings,
  billing,
  orders,
  favorites,
  help,
  legal,
  errors,
};
